import { fileMixin } from './FileMixin';

export var fileMixinVideoImage = {
    mixins: [fileMixin],
    data: () => ({
        videoImageData: { path: '', name: '' },
        videoImageOptional: false,
        videoImageFiles: [],
        videoImageTypes: ['.mp4', '.webm', '.png', '.jpeg', '.jpg'],
        videoImageValid: true
    }),
    computed: {
        videoImageRules: function () {
            return [
                value => {
                    let required = !(this.videoImageOptional || !(!value || (Array.isArray(value) && !value[0])));
                    return required ? 'Fichier requis' : true;
                },
                value => {
                    let extension = value ? this.getExtension(value.name) : '';
                    let allTypes = this.videoImageTypes.reduce((acc, item) => acc + ' *' + item, '');
                    let required = !(this.videoImageOptional && extension === '');
                    let extensionValid = !this.videoImageTypes.includes('.' + extension);
                    return required && extensionValid ? 'Formats attendus:' + allTypes : true;
                },
                value => {
                    let required = !(this.videoImageOptional && !value);
                    let validSize = !(value && value.size < 4000000);
                    return required && validSize ? 'La taille du fichier doit être inférieur à 4 MB!' : true;
                }
            ];
        }
    },
    methods: {
        initVideoImageFiles: function (file, path, optional = false) {
            this.videoImageOptional = optional;
            if (file && file.path !== '') {
                this.createFile(path + file.path, file.name).then((data) => {
                    this.videoImageFiles = data;
                    this.videoImageValid = this.validateVideoImage(this.videoImageFiles);
                });
            }
        },
        validateVideoImage: function (videoImage) {
            return this.videoImageRules.reduce((acc, item) => acc && item(videoImage) && typeof item(videoImage) !== 'string', true);
        },
        onChangeVideoImage: function (videoImage) {
            if (!videoImage && this.videoImageOptional) {
                this.videoImageData = { path: '', name: '' };
                this.videoImageValid = true;
                return;
            }
            this.videoImageValid = this.validateVideoImage(videoImage);
            this.onChangeFile(videoImage, this.videoImageValid).then((data) => {
                this.videoImageFiles = data.file;
                this.videoImageData = data.shortFile;
            }).catch((err, data) => {
                this.$toasted.error(err);
                this.videoImageData = data;
            });
        }
    }
};
